export default {
  '请求': {
    '加载中': 'Ładowanie',
    '请求失败': 'Żądanie nie powiodło się',
    '登录已过期': 'Sesja wygasła',
    '网络连接失败': 'Błąd połączenia sieciowego',
    '请重新登录': 'Zaloguj się ponownie',
    '没有权限访问': 'Brak dostępu',
    '请求的资源不存在': 'Nie znaleziono zasobu',
    '服务器错误': 'Błąd serwera',
    '网络错误': 'Błąd sieci',
    '刷新成功': 'Odświeżono',
    '获取中': 'Ładowanie...',
    '账号下线': 'Konto offline',
    '功能已禁用': 'Funkcja wyłączona',
  },
  '导航': {
    '首页': 'Strona główna',
    '选妃': 'Wybór',
    '认证': 'Weryfikacja',
    '影院': 'Wideo',
    '个人': 'Moje',
  },
  '首页': {
    '注册': 'Rejestracja',
    '影片': 'Wideo',
    '女团': 'Dziewczyny',
    '热门城市': 'Popularne miasta:',
    '经理预订': 'Rezerwacja menedżera',
    '看更多': 'Więcej',
    '身份验证': 'Zweryfikowano',
    '身高': 'Wzrost',
    '胸围': 'Biust',
    '服务城市': 'Miasto:',
  },
  '女团': {
    '女团': 'Dziewczyny',
    '选妃': 'Wybór',
    '身份验证': 'Zweryfikowano',
    '身高': 'Wzrost',
    '胸围': 'Biust',
    '服务城市': 'Miasto:',
    '注册': 'Rejestracja',
    '请联系顾问或接待员': 'Skontaktuj się z doradcą',
  },
  '登录': {
    '登录会员视窗': 'Logowanie członka',
    '请输入用户名': 'Nazwa użytkownika',
    '请输入密码': 'Hasło',
    '登录': 'Zaloguj się',
    '没有账号马上注册': 'Nie masz konta? Zarejestruj się',
    '登录成功': 'Logowanie pomyślne',
    '登录注册': 'Logowanie / Rejestracja',
    '登录可享受更多服务': 'Zaloguj się, aby uzyskać więcej usług!',
  },
  '注册': {
    '注册': 'Rejestracja',
    '登录': 'Zaloguj się',
    '请输入用户名': 'Nazwa użytkownika',
    '用户名规则': '6-20 liter/cyfr',
    '请输入密码': 'Hasło',
    '密码规则': '6-16 liter i cyfr',
    '请输入验证码': 'Kod weryfikacyjny',
    '验证码规则': 'Wpisz 4-znakowy kod',
    '请输入邀请码': 'Kod zaproszenia',
    '邀请码规则': 'Wpisz kod agenta',
    '同意协议': 'Mam ukończone 18 lat i akceptuję Regulamin',
    '立即注册': 'Zarejestruj się teraz',
    '注册中': 'Rejestracja...',
    '已有账号马上登录': 'Masz konto? Zaloguj się',
    '注册成功': 'Zarejestrowano!',
    '注册失败': 'Rejestracja nieudana: ',
    '验证码错误': 'Nieprawidłowy kod',
    '请同意注册条款': 'Zaakceptuj regulamin',
    '用户名已存在': 'Nazwa użytkownika już istnieje',
    '邀请码无效': 'Nieprawidłowy kod zaproszenia',
  },
  '抢单': {
    '今日收益': 'Dzisiejszy dochód',
    '余额': 'Saldo',
    '订单': 'Zamówienia',
    '开始抢单': 'Rozpocznij',
    '当前等级': 'Poziom:',
    '提现': 'Wypłata',
    '在线客服': 'Wsparcie',
    '充值': 'Doładowanie',
    '幸运任务': 'Szczęśliwe zadanie',
    '幸运订单': 'Szczęśliwe zamówienie',
    '幸运订单提示': 'Gratulacje! To zamówienie z wysoką prowizją',
    '恭喜获得幸运订单': 'Odblokowano szczęśliwe zamówienie!',
    '提交订单': 'Złóż zamówienie',
    '未完成订单提示': 'Masz nieopłacone zamówienie. Najpierw zapłać.',
    '正在获取订单': 'Ładowanie zamówienia...',
    '抢单时间': 'Czas:',
    '订单号': 'Nr zamówienia',
    '订单总额': 'Suma',
    '佣金': 'Prowizja',
    '商品单价': 'Cena',
    '预计收入': 'Szac. zarobki',
    '确认支付': 'Zapłać teraz',
    '确认付款': 'Potwierdź płatność',
    '支付处理中': 'Przetwarzanie...',
    '取消': 'Anuluj',
    '去查看': 'Zobacz',
    '暂无可用订单': 'Brak dostępnych zamówień',
    '正在加载用户信息': 'Ładowanie danych użytkownika...',
    '今日抢单已达上限': 'Osiągnięto dzienny limit',
    '余额不足无法获取订单': 'Niewystarczające saldo',
    '获取订单失败': 'Nie udało się pobrać zamówienia',
    '支付成功': 'Płatność pomyślna',
    '支付失败': 'Płatność nieudana',
    '支付失败请重试': 'Płatność nieudana, spróbuj ponownie',
    '请完成任务单后进入': 'Najpierw ukończ zadania',
    '请设置收款卡': 'Powiąż adres wypłaty',
  },
  '我的': {
    '我的页面': 'Moja strona',
    '钻石': 'Diament',
    '信誉分': 'Kredyt',
    '开通专属会员': 'Otwórz VIP',
    '开启一次日期不限': 'Jednorazowe odblokowanie, bez limitu daty',
    '提现': 'Wypłata',
    '历史订单': 'Historia zamówień',
    '充值记录': 'Historia doładowań',
    '提现记录': 'Historia wypłat',
    '添加钱包地址': 'Dodaj adres portfela',
    '邀请码': 'Kod zaproszenia:',
    '余额': 'Saldo',
    '退出登陆': 'Wyloguj się',
  },
  '会员': {
    '会员等级': 'Członkostwo:',
    '普通等级': 'Normalny',
    '当前等级': 'Aktualny',
    '立即开通': 'Aktywuj',
    '免费说明': '(Darmowe filmy) (Darmowe dopasowanie)',
    '所需投资': 'Wymagane',
    '佣金': 'Prowizja',
    '订单': 'Zamówienia',
    '加入': 'Dołącz >>',
  },
  '充值': {
    '充值': 'Doładowanie',
    '当前余额': 'Saldo',
    '余额': 'Saldo: ',
    '个': '',
    '充值金额': 'Kwota',
    '请输入充值金额': 'Wpisz kwotę',
    '快速选择金额': 'Szybka kwota',
    '确认': 'Potwierdź',
    '提示': 'Wskazówki',
    '金额错误': 'Nieprawidłowa kwota',
    '立即充值': 'Doładuj teraz',
    '提交成功': 'Wysłano, oczekuje na weryfikację',
  },
  '提现': {
    '提现': 'Wypłata',
    '兑换积分': 'Wypłać punkty',
    '最大提款金额': 'Maks. kwota',
    '资金密码': 'Hasło funduszy',
    '余额': 'Saldo: ',
    '个': '',
    '钱包地址': 'Adres portfela: ',
    '请选择提款地址': 'Wybierz adres wypłaty',
    '暂无绑定地址': 'Brak powiązanego adresu',
    '提交': 'Wyślij',
    '通知': 'Uwaga:',
    '单笔最大提现': '1. Maks. na wypłatę: ',
    '单笔最低提现': '2. Min. na wypłatę: ',
    '检查姓名账号': '3. Sprawdź imię i konto',
    '注意提款费用': '4. Uwzględnij opłaty za wypłatę',
    '请填写正确的金额': 'Wpisz prawidłową kwotę',
    '当前余额': 'Saldo',
    '提现金额': 'Kwota',
    '请输入提现数量': 'Wpisz kwotę',
    '立即提现': 'Wypłać teraz',
    '交易密码': 'Hasło płatności',
    '请输入交易密码': 'Wpisz hasło płatności',
    '请先设置提现密码': 'Najpierw ustaw hasło wypłaty',
  },
  '绑卡': {
    '添加钱包地址': 'Dodaj adres portfela',
    '钱包地址信息': 'Dane portfela',
    '请输入支付卡信息': 'Wpisz adres portfela',
    '加密货币类型': 'Typ krypto',
    '请选择加密货币类型': 'Wybierz typ krypto',
    '钱包地址': 'Adres portfela',
    '请输入钱包地址': 'Wpisz adres portfela',
    '绑卡说明': 'Drogi użytkowniku, dla bezpieczeństwa środków powiąż prawdziwe imię i ustaw hasło wypłaty. Imię musi być zgodne z kontem.',
    '确定绑卡': 'Potwierdź powiązanie',
    '绑卡提示': 'Wskazówka: powiąż duży bank. Aby zmienić, skontaktuj się z pomocą.',
    '请先设置姓名': 'Najpierw ustaw imię!',
    '已绑定不可修改': 'Adres już powiązany. Skontaktuj się z pomocą, aby zmienić.',
  },
  '订单历史': {
    '订单历史': 'Historia zamówień',
    '数据为空': 'Brak danych',
    '订单号': 'Nr zamówienia: ',
    '已完成': 'Zakończone',
    '处理中': 'Przetwarzanie',
    '完成订单': 'Zakończ zamówienie',
    '订单金额': 'Kwota: ',
    '佣金': 'Prowizja: ',
    '创建时间': 'Utworzono: ',
    '上一页': 'Poprz.',
    '下一页': 'Nast.',
    '获取失败': 'Nie udało się załadować historii',
    '获取失败重试': 'Nie udało się załadować, spróbuj ponownie',
    '未知': 'Nieznany',
    '完成成功': 'Zamówienie zakończone!',
    '完成失败': 'Zakończenie nieudane: ',
    '完成失败重试': 'Zakończenie nieudane, spróbuj ponownie',
    '请输入支付密码': 'Wpisz hasło płatności',
    '请先设置支付密码': 'Najpierw ustaw hasło płatności',
  },
  '入金记录': {
    '标题': 'Historia doładowań',
    '数据为空': 'Brak danych',
    '认证结果': 'Wynik',
    '下单积分': 'Punkty: ',
    '下单时间': 'Zamówiono: ',
    '结算时间': 'Rozliczono: ',
    '待审核': 'Oczekujące',
    '已通过': 'Zatwierdzone',
    '已拒绝': 'Odrzucone',
    '暂无数据': 'Brak danych',
  },
  '提现记录': {
    '标题': 'Historia wypłat',
    '数据为空': 'Brak danych',
    '待审核': 'Oczekujące',
    '审核成功': 'Zatwierdzone',
    '审核退回': 'Odrzucone',
    '未知状态': 'Nieznany',
    '金额': 'Kwota: ',
    '说明': 'Uwaga: ',
    '提交时间': 'Wysłano: ',
    '审核时间': 'Sprawdzono: ',
    '已通过': 'Zatwierdzone',
    '已拒绝': 'Odrzucone',
    '暂无数据': 'Brak danych',
  },
  '资料': {
    '基本信息': 'Profil',
    '头像': 'Awatar',
    '姓名': 'Imię',
    '未设置': 'Nie ustawiono',
    '性别': 'Płeć',
    '男': 'Mężczyzna',
    '女': 'Kobieta',
    '未知': 'Nieznany',
    '设定': 'Ustawienia',
    '账号信息': 'Konto',
    '更改登录密码': 'Zmień hasło logowania',
    '设定支付密码': 'Ustaw hasło płatności',
    '退出登录': 'Wyloguj się',
    '设置': 'Ustawienia',
    '登录密码': 'Hasło logowania',
    '资金密码': 'Hasło funduszy',
    '提现密码已设置': 'Hasło płatności ustawione. Skontaktuj się z pomocą, aby zmienić.',
    '已设置': 'Ustawiono',
    '修改真实姓名': 'Edytuj prawdziwe imię',
    '请输入真实姓名': 'Wpisz prawdziwe imię',
    '真实姓名说明': 'Prawdziwe imię musi być zgodne z danymi portfela',
    '提交': 'Wyślij',
    '请勿重复设置': 'Już ustawiono!',
    '修改登录密码': 'Zmień hasło logowania',
    '设置资金密码': 'Ustaw hasło funduszy',
    '保存': 'Zapisz',
    '旧密码': 'Stare hasło',
    '请输入旧密码': 'Wpisz stare hasło',
    '新密码': 'Nowe hasło',
    '请输入新密码': 'Wpisz nowe hasło',
    '确认密码': 'Potwierdź hasło',
    '请再次输入新密码': 'Wpisz nowe hasło ponownie',
    '请填写完整': 'Wypełnij wszystkie pola!',
    '两次密码不一致': 'Hasła nie są zgodne',
    '性别修改': 'Edytuj płeć',
    '个人报表': 'Raport osobisty',
    '任务金额积分': 'Kwota zadania (punkty)',
    '盈利公式': 'Zysk = Wygrana - Kwota zadania',
    '任务金额': 'Kwota zadania',
    '充值金额': 'Doładowanie',
    '金额': 'Kwota',
    '中奖金额': 'Kwota wygranej',
    '个人情报': 'Profil',
    '身高': 'Wzrost:',
    '胸围': 'Biust:',
    '收费区间': 'Zakres cen:',
    '系统公告': 'Ogłoszenia',
  },
  '客服': {
    '联系客服': 'Kontakt z pomocą',
    '在线客服': 'Pomoc online',
    '暂无客服': 'Brak dostępnej pomocy',
    '联系': 'Kontakt',
    '服务时间': 'Całodobowa pomoc 24/7',
  },
  '影院': {
    '影院': 'Kino',
    '全部': 'Wszystkie',
    '最高分': 'Najwyżej oceniane',
    '播放': 'Odtworzenia: ',
    '次播放': ' odtworzeń',
    '热门推荐': 'Popularne',
    '播放次数': 'Odtworzenia:',
    '请充值后观看': 'Doładuj, aby oglądać',
  },
  '语言切换器': {
    '切换语言': 'Język',
    '语言': 'Język',
  },
}
